
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"m8.181 7.6 6.019-4.474a.5.5 0 0 1 .8.4v8.944a.5.5 0 0 1-.8.4l-6.019-4.47a.5.5 0 0 1 0-.8Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"m1.181 7.6 6.021-4.473a.5.5 0 0 1 .8.4v8.944a.5.5 0 0 1-.8.4l-6.021-4.471a.5.5 0 0 1 0-.8Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  